import Swiper from "swiper";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

export default function () {
    const root = document.querySelector(
        '.o-inadimplencia__swiper[data-swiper="inadimplencia"]',
    );
    if (!root) return;

    const slider = new Swiper(root, {
        modules: [Pagination],
        slidesPerView: "auto",
        spaceBetween: 10,
        autoHeight: true,
        pagination: {
            el: root.querySelector(".o-inadimplencia__pagination"),
            type: "progressbar",
        },
        breakpoints: {
            768: {
                slidesPerView: 4,
                spaceBetween: 12,
                allowTouchMove: false,
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 14,
                allowTouchMove: false,
            },
        },
    });

    return slider;
}
